function modalDownload() {
	let modal = document.querySelector('.js-flex-academy-download-form');

	if (modal) {
		let modalBtns = document.querySelectorAll('.js-download-modal-btn');
		let overlay = document.querySelector('.js-modal-overlay-dark');

		let closeBtn = modal.querySelector('.js-modal-close');

		let downloadLinkElement = document.createElement('a');

		document.body.appendChild(downloadLinkElement);

		function openModal(downloadLink) {
			modal.classList.add('open');
			overlay.classList.add('open');

			modal.setAttribute('data-download-link', downloadLink);

			let form = modal.querySelector('form');

			form.removeEventListener('submit', formSubmitHandler);

			form.addEventListener('submit', formSubmitHandler);
		}

		function formSubmitHandler(e) {
			handleFormSubmit(modal.getAttribute('data-download-link'));
		}

		function handleFormSubmit(downloadLink) {
			downloadLinkElement.href = downloadLink;
			downloadLinkElement.download = '';
			downloadLinkElement.click();
			closeModal();
		}

		function closeModal() {
			modal.classList.remove('open');
			overlay.classList.remove('open');
			modal.removeAttribute('data-download-link');
		}

		modalBtns.forEach(function (btn) {
			btn.addEventListener('click', function (e) {
				e.preventDefault();
				let downloadLink = btn.getAttribute('data-download-file');

				openModal(downloadLink);
			});
		});

		closeBtn.addEventListener('click', closeModal);

		overlay.addEventListener('click', function (event) {
			if (event.target === overlay) {
				closeModal();
			}
		});
	}
}

export default modalDownload;
